import api from './client';
import type { Offer, CreateOfferInput, UpdateOfferInput } from './types';

export async function getOffers(): Promise<Offer[]> {
  return api.get<Offer[]>('/admin/offers');
}

export async function createOffer(data: CreateOfferInput): Promise<Offer> {
  return api.post<Offer>('/admin/offers', data);
}

export async function updateOffer(id: string, data: UpdateOfferInput): Promise<Offer> {
  return api.put<Offer>(`/admin/offers/${id}`, data);
}

export async function deleteOffer(id: string): Promise<{ message: string }> {
  return api.delete<{ message: string }>(`/admin/offers/${id}`);
}

export interface GeoGapRow {
  code: string;
  users: number;
  projects: number;
  offersPaused: number;
  pausedPartners: string[];
  apps: string[];
  status: 'none' | 'paused';
}

export interface GeoGapsResponse {
  days: number;
  min: number;
  rows: GeoGapRow[];
}

export async function getGeoGaps(params: { days: number; min: number }): Promise<GeoGapsResponse> {
  const qs = new URLSearchParams({ days: String(params.days), min: String(params.min) });
  return api.get<GeoGapsResponse>(`/admin/offers/geo-gaps?${qs}`);
}
